import {API_URL} from "../../dev";

import "isomorphic-fetch";

class SeatStateApi {
	async getSeatState(merchantId, themeName, eventUUID) {
		try {
			const response = await fetch(
				`${API_URL}/v2/seat-state/${merchantId}_${themeName}/${eventUUID}`, {
					method: 'GET',
					headers: {
						Accept: 'application/json',
					},
				});
			const obj = await response.json();
			if (response.ok) {
				return obj;
			}
			throw obj;
		} catch (e) {
			console.error(`Error occurred in getSeatState for EventUUID:
			 ${JSON.stringify(eventUUID)}: ${JSON.stringify(e)}`);
			throw e;
		}
	}
}

const seatStateApi = new SeatStateApi();
export default seatStateApi;
